module.exports = __webpack_public_path__ + "static/media/detail33.b0c7d10c.svg";